<template>
  <BaseOverlay
    class="whatsapp-paid-promo"
    close-btn
    @close="closeModal"
    @click.native.self.exact="dismissModal"
  >
    <div class="whatsapp-paid-promo__dialog">
      <img
        src="/img/renova-dashboard/icons/whatsAppIntegration.svg"
        alt="WhatsApp"
        class="whatsapp-paid-promo__icon"
      >

      <h3 class="whatsapp-paid-promo__title">{{ $t('whatsappPaidPromo.title') }}</h3>
      <p class="whatsapp-paid-promo__subtitle">{{ $t('whatsappPaidPromo.subtitle') }}</p>

      <ul class="whatsapp-paid-promo__features">
        <li>{{ $t('whatsappPaidPromo.feature1') }}</li>
        <li>{{ $t('whatsappPaidPromo.feature2') }}</li>
        <li>{{ $t('whatsappPaidPromo.feature3') }}</li>
      </ul>

      <BaseButton
        class="whatsapp-paid-promo__button"
        @click="connectWhatsApp"
      >
        {{ $t('whatsappPaidPromo.connectBtn') }}
      </BaseButton>
    </div>
  </BaseOverlay>
</template>

<script>
import BaseOverlay from '@/views/RenovaDashboard/components/ui-kit/BaseOverlay';
import BaseButton from '@/views/RenovaDashboard/components/ui-kit/Buttons/BaseButton';
import {logAmplitudeEvent} from '@/utils/amplitude';

export default {
  name: 'WhatsAppPaidPromoModal',
  components: {
    BaseOverlay,
    BaseButton,
  },
  mounted() {
    logAmplitudeEvent('whatsapp_modal_shown');
  },
  methods: {
    connectWhatsApp() {
      logAmplitudeEvent('whatsapp_connect_clicked');
      this.$emit('confirm');
      this.$router.push({
        path: '/admin/integrations',
        query: {openConnectModal: true}
      });
    },
    closeModal() {
      logAmplitudeEvent('whatsapp_modal_dismissed');
      this.$emit('close');
    },
    dismissModal() {
      logAmplitudeEvent('whatsapp_modal_dismissed');
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.whatsapp-paid-promo {
  display: flex;
  justify-content: center;
  align-items: center;

  &__dialog {
    background-color: #fff;
    border-radius: 24px;
    padding: 40px;
    width: 480px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);
  }

  &__close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    font-size: 20px;
    color: var(--solid-dark-purple);
    opacity: 0.5;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }

  &__icon {
    width: 64px;
    height: 64px;
    margin-bottom: 24px;
  }

  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: var(--solid-black-purple);
    margin: 0 0 12px;
  }

  &__subtitle {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: var(--solid-dark-purple);
    margin: 0 0 24px;
  }

  &__features {
    list-style: none;
    padding: 0;
    margin: 0 0 32px;
    text-align: left;
    width: 100%;

    li {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: var(--solid-black-purple);
      margin-bottom: 0px;
      position: relative;
      padding-left: 24px;

      &::before {
        content: "•";
        position: absolute;
        left: 0;
        color: var(--solid-black-purple);
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__button {
    min-width: 200px;
    height: 48px;
    font-size: 16px;
  }
}
</style>
